var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8942 3.75764L10.836 14.7825C9.8626 16.4047 7.48984 16.4069 6.51517 14.7825L0.457214 3.75764C-0.537819 2.10001 0.666866 0.000917672 2.61711 0.000917672H14.7338C16.6824 0.000917672 17.8893 2.09832 16.8942 3.75764ZM8.67557 1.99051C8.12161 1.99051 7.67069 2.43691 7.67069 2.98531C7.67069 3.53371 8.12161 3.98011 8.67557 3.98011C9.22952 3.98011 9.68045 3.53371 9.68045 2.98531C9.68045 2.43691 9.22952 1.99051 8.67557 1.99051ZM9.68045 5.96971C9.68045 5.42131 9.22952 4.97491 8.67557 4.97491C8.12161 4.97491 7.67069 5.42131 7.67069 5.96971V10.9437C7.67069 11.4921 8.12161 11.9385 8.67557 11.9385C9.22952 11.9385 9.68045 11.4921 9.68045 10.9437V5.96971Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.9c88f31b87106610c9bd5cb9da4ee509.svg";
export { ForwardRef as ReactComponent };